"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Ref, Component, PropSync } from "vue-property-decorator";
import { DialogComponent } from "@/components/core";
import UiDialog from "@/components/dialog/UiDialog.vue";
import draggable from "vuedraggable";
import ItemShop from "@/components/virtual-shop/elements/item-shop/ItemShop.vue";
import _ from "lodash";
import i18n from "@/lang";
import API from "@ym-framework/api-utils";
let ItemLauncher = class extends DialogComponent {
  constructor() {
    super(...arguments);
    this.disabled = false;
  }
  launcher(item) {
    return __async(this, null, function* () {
      this.$emit("launcher", item);
    });
  }
  goHelp(no) {
    window.open(`https://www.kuajingvs.com/help2/${no}`, "__blank");
  }
  get options() {
    return {
      disabled: !this.disabled
    };
  }
  created() {
    this.onEnd = _.debounce(() => __async(this, null, function* () {
      const _shopIds = _.map(this._item.shops, "id");
      yield API.post(`api://base.auth.pro/v1/virtual-desktops/${this._item.id}/shops-sort`, {
        shopIds: _shopIds
      });
    }), 800);
  }
  static create(item) {
    const _vue = new this({
      i18n,
      el: document.createElement("div"),
      propsData: {
        item
      }
    });
    return _vue;
  }
  close() {
    this.dialog.hide();
  }
};
__decorateClass([
  PropSync("item")
], ItemLauncher.prototype, "_item", 2);
__decorateClass([
  Ref("_dialog")
], ItemLauncher.prototype, "dialog", 2);
ItemLauncher = __decorateClass([
  Component({
    components: {
      UiDialog,
      ItemShop,
      draggable
    }
  })
], ItemLauncher);
export {
  ItemLauncher as default
};
